import * as Tone from 'tone'
import Numbers from './utils/Sounds'
import helpers from './utils/helpers'
import EventEmitter from './utils/EventEmitter'
import CONSTANTS from './utils/config'
class HearingTestNumbers {
  
  constructor (headphoneType, lang) {
    this.headphoneType = headphoneType
    this.lang = lang
    this.channels = Object.values(this.headphoneType.channels)
    this.numbers = Numbers.numbers
    this.stages = CONSTANTS.HEARING_TEST.NUMBERS_NOISE_DECIBEIS
    this.currentStage = 0
    this.eventEmitter = new EventEmitter()
    this.questions = []
    this.player = null
    this.noise = null
    this.answersFailed = 0
    this.failedLevel = false
    this.isPlaying = false
    this.currentNumberOrder = 0
    this.results = {
      left: [],
      right: []
    }
    this.percentageCompleted = 0
  }

  buildQuestions () {
    let array = this.numbers.concat()

    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1))
      let temp = array[i]
      array[i] = array[j]
      array[j] = temp
    }

    return array.slice(0, 3)
  }

  playInstructionsLoop () {
    this.player = new Tone.Player({
      url: `./public/numbers_instructions_${this.lang}.mp3`,
      autostart: true,
      loop: true,
      volume: CONSTANTS.HEARING_TEST.NUMBERS_DECIBEIS
    }).toDestination()
  }
  
  init () {
    if (this.player !== null) {
      this.player.disconnect()
    }
    this.currentChannel = this.channels[0]
    this.eventEmitter.emit('channelUpdated', this.currentChannel)
    this.playInstructions()
    this.eventEmitter.emit('instructionsStarted')
    setTimeout(() => {
      this.eventEmitter.emit('instructionsEnded')
      this.playLevel()
    }, 2500)
  }

  resetHearingTest () {
    this.answersFailed = 0
    this.currentStage = 0
    this.currentChannel = this.channels[1]
    this.eventEmitter.emit('channelUpdated', this.currentChannel)
    this.playCurrentStage()
  }

  playLevel () {
    // console.log('new level')
    this.questions = this.buildQuestions()
    this.failedLevel = false
    this.currentNumberOrder = 0
    // console.log(this.questions[0].name + ', ' + this.questions[1].name + ', ' + this.questions[2].name)
    this.eventEmitter.emit('levelStarted')

    let volume = this.stages[this.currentStage]

    // console.log('noise volume: ' + volume)

    this.isPlaying = true
    this.play(this.questions[0], volume)
    setTimeout(() => {
      this.play(this.questions[1], volume)
    }, 1500)
    setTimeout(() => {
      this.play(this.questions[2], volume)
    }, 3000)
    setTimeout(() => {
      this.isPlaying = false
      this.eventEmitter.emit('soundEnded')
    }, 4500)
  }

  playInstructions () {
    new Tone.Player({
      url: `./public/numbers_choose_${this.lang}.mp3`,
      autostart: true,
      loop: false,
      volume: CONSTANTS.HEARING_TEST.NUMBERS_DECIBEIS
    }).toDestination()
  }
  
  play (number, volume) {
    this.isPlaying = true
    if (this.player !== null) {
      this.player.disconnect()
    }
    if (this.noise !== null) {
      this.noise.disconnect()
    }

    this.noise = new Tone.Noise({
      type  : 'white',
      volume
    }).start().stop('+1.5')
    this.player = new Tone.Player({
      url: `./public/${number.audio}_${this.lang}.mp3`,
      autostart: true,
      loop: false,
      volume: CONSTANTS.HEARING_TEST.NUMBERS_DECIBEIS
    })

    if (this.currentChannel !== 'single') {
      // Merge is used to decide which channel should the beep play
      let merge = new Tone.Merge().toDestination()
      this.noise.connect(merge, 0, this.currentChannel === 'left' ? 0 : 1)
      this.player.connect(merge, 0, this.currentChannel === 'left' ? 0 : 1)
    } else {
      this.noise.toMaster()
      this.noise.toDestination()
      this.player.toDestination()
    }
  }

  playCurrentStage () {
    setTimeout(() => {
      this.playLevel()
    }, 2000)
  }
  
  evaluate (answer) {
    // console.log(this.questions[this.currentNumberOrder].name)
    // console.log(answer)
    if (this.questions[this.currentNumberOrder].name !== answer) {
      this.eventEmitter.emit('answer-result', {number: answer, result: false})
      this.answersFailed++
      this.failedLevel = true
    } else {
      this.eventEmitter.emit('answer-result', {number: answer, result: true})
    }

    if (this.currentNumberOrder < 2) {
      this.currentNumberOrder++
    } else {
      if (this.isPlaying) {
        this.player.stop()
        this.noise.stop()
        this.isPlaying = false
        this.eventEmitter.emit('soundEnded')
      }
      this.currentChannel === 'single' ? this.percentageCompleted += 0.1 : this.percentageCompleted += 0.05
      this.eventEmitter.emit('levelEnded', this.percentageCompleted)
      if (!this.failedLevel) {
        this.currentStage += 1
      }

      if (this.currentStage <= this.stages.length - 1 && this.answersFailed < 6) {
        this.playCurrentStage()
      } else {
        if (this.currentChannel === 'single') {
          this.results['left'].push({lastStage: this.currentStage > this.stages.length - 1 ? 'end' : this.stages[this.currentStage]})
          this.results['right'].push({lastStage: this.currentStage > this.stages.length - 1 ? 'end' : this.stages[this.currentStage]})
        } else {
          this.results[this.currentChannel].push({lastStage: this.currentStage > this.stages.length - 1 ? 'end' : this.stages[this.currentStage]})
        }

        if (Object.values(this.results).some(ear => ear.length === 0)) {
          this.resetHearingTest()
        } else {
          this.player.disconnect()
          this.noise.disconnect()
          setTimeout(() => {
            this.eventEmitter.emit('numbersTestEnded', this.results)
          }, 1000)
        }
        // if (this.currentStage > this.stages.length - 1) {
        //   console.log('Numbers test ended with complete success.')
        // } else {
        //   console.log('Numbers test ended on level with noise at ', this.stages[this.currentStage], 'dBs.')
        // }
      }
    }
  }
}

export default HearingTestNumbers